import { Link, useLocation } from 'react-router-dom';
import { useShop } from '../shop';
import { useCart } from '../store';

export function Header() {
  const { slug, shop, session } = useShop();
  const cart = useCart(slug);
  const count = cart.reduce((n, l) => n + l.qty, 0);
  const { pathname } = useLocation();
  const atHome = pathname === `/${slug}` || pathname === `/${slug}/`;

  return (
    <header className="sticky top-0 z-20 border-b border-stone-200/70 bg-white/90 backdrop-blur dark:border-stone-800 dark:bg-stone-950/90">
      <div className="mx-auto flex h-14 max-w-5xl items-center gap-3 px-4">
        {!atHome && (
          <Link to={`/${slug}`} aria-label="Back to the shop" className="-ml-2 grid size-9 place-items-center rounded-full text-stone-600 hover:bg-stone-100 dark:text-stone-300 dark:hover:bg-stone-800">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
          </Link>
        )}
        <Link to={`/${slug}`} className="flex min-w-0 items-center gap-2.5">
          {shop.logoUrl ? (
            <img src={shop.logoUrl} alt="" className="size-8 rounded-lg object-cover" />
          ) : (
            <span className="grid size-8 place-items-center rounded-lg bg-[var(--brand)] text-sm font-bold text-white">{shop.name.slice(0, 1).toUpperCase()}</span>
          )}
          <span className="truncate font-semibold text-stone-900 dark:text-stone-100">{shop.name}</span>
        </Link>
        <div className="ml-auto flex items-center gap-2">
          {session.contactName && <span className="hidden text-sm text-stone-500 sm:inline">Hi, {session.contactName.split(' ')[0]}</span>}
          <Link to={`/${slug}/cart`} aria-label={`Cart, ${count} items`} className="relative grid size-10 place-items-center rounded-full text-stone-700 hover:bg-stone-100 dark:text-stone-200 dark:hover:bg-stone-800">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 6h15l-1.5 9h-12z" /><path d="M6 6L5 3H2" /><circle cx="9" cy="20" r="1" /><circle cx="18" cy="20" r="1" /></svg>
            {count > 0 && (
              <span className="absolute -right-0.5 -top-0.5 min-w-5 rounded-full bg-[var(--brand)] px-1 text-center text-[11px] font-semibold leading-5 text-white">{count > 99 ? '99+' : count}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
